module.exports = __webpack_public_path__ + "images/signature-3e5ecb3062270fee5fbd0874bdb99a32.jpg";